import { useState } from "react"
import { filter, get } from "lodash"

export default function useDeleter(data, idField, selectedRows, setDialog) {
  const [deletingItems, setDeletingItems] = useState(null)

  function startDelete(id) {
    // deleted multiple selected rows
    if (id) {
      setDeletingItems(filter(data, datum => get(datum, idField) === id))
    } else {
      setDeletingItems(filter(data, datum => !!selectedRows[get(datum, idField)]))
    }

    setDialog("delete")
  }

  return [deletingItems, startDelete]
}
